module.exports = __webpack_public_path__ + "img/结构.40914b2e.svg";